// extracted by mini-css-extract-plugin
export default {"root":"VoteResult_root__ml70Q","main":"VoteResult_main__VQaPV","title":"VoteResult_title__0RaWI","tip":"VoteResult_tip__KCGEz"};